import React, { useState, useEffect } from 'react';
import { FormGroup, FormControlLabel, Checkbox, Button } from '@mui/material';
import '../../Estimation.css';
import axiosInstance from 'interceptors/axiosInstance';
import { getAddOnDetailsByProgramType, saveAddonDetailsAPI } from 'api/api';
import Spinnerprogress from 'ui-component/circular-progress/Spinnerprogress';
import Notification from 'ui-component/notification/notification';

const AddOns = ({ view, formState, ClientId, ProjectId, EstimationId, Version, onAddonSaved }) => {
  const [addOns, setAddOns] = useState([]);
  const [visibleAddOns, setVisibleAddOns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [checkedData, setCheckedData] = useState([]);
  const [openNotification, setOpenNotification] = useState(false);

  const handleChange = (adonId) => {
    if (checkedData.includes(adonId)) {
      setCheckedData(checkedData.filter((item) => item !== adonId));
    } else {
      setCheckedData([...checkedData, adonId]);
    }
  };

  const handleSave = async () => {
    const selectedAddOns = {
      addonList: checkedData,
      instanceType: formState.InstanceTypeValue,
      programType: formState.ProgramTypeValue,
      clientId: ClientId,
      projectId: ProjectId,
      estimationId: EstimationId,
      version: Version
    };

    await axiosInstance
      .post(saveAddonDetailsAPI, selectedAddOns)
      .then((response) => {
        if (response.status === 200) {
          setOpenNotification(true);
          // Trigger refresh of cost components when addons are saved
          if (onAddonSaved) {
            onAddonSaved();
          }
        }
      })
      .catch((error) => console.log(error));
  };

  const fetchData = async () => {
    await axiosInstance
      .get(getAddOnDetailsByProgramType, {
        params: {
          InstanceType: formState.InstanceTypeValue,
          ProgramType: formState.ProgramTypeValue,
          EstimationID: EstimationId,
          Version: Version,
          ProjectId: ProjectId,
          ClientId: ClientId
        }
      })
      .then((response) => {
        setAddOns(response.data);
        setVisibleAddOns(response.data.filter((item) => item.IsEnabled === true));
        setCheckedData(response.data.filter((item) => item.IsSelected === true).map((item) => item.AddonId));
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    setIsLoading(true);
    fetchData();
    setIsLoading(false);
  }, []);

  return (
    <>
      {isLoading ? (
        <Spinnerprogress />
      ) : (
        <FormGroup className="add-ons-diplay">
          {visibleAddOns.length > 0 ? (
            addOns.map((item) => {
              return (
                <FormControlLabel
                  key={item.AddonId + item.BaseFeature}
                  // disabled={view}
                  control={
                    <Checkbox
                      disabled={item.IsEnabled && !view ? false : true}
                      checked={checkedData.includes(item.AddonId)}
                      onChange={() => handleChange(item.AddonId)}
                    />
                  }
                  label={item.BaseFeature}
                  className="add-ons-checkbox"
                />
              );
            })
          ) : (
            <h3>No add-ons</h3>
          )}
        </FormGroup>
      )}
      <Notification openNotification={openNotification} setOpenNotification={setOpenNotification} message={'Saved Successfully'} />
      <Button
        size="1.3rem"
        type="button"
        variant="contained"
        color="secondary"
        sx={{ marginTop: '20px', visibility: !view && visibleAddOns.length > 0 ? 'visible' : 'hidden' }}
        onClick={handleSave}
      >
        Save
      </Button>
    </>
  );
};

export default AddOns;
